import { formatPrice } from '../../../../../../utils/format'
import { FormatOption } from './types'

const FORMATTERS: Record<FormatOption, (value: number) => string> = {
  integer: (number) => number?.toLocaleString('pt-BR', { maximumFractionDigits: 0 }),
  decimal: (number) => number?.toFixed(2),
  currency: formatPrice,
  percentage: (number) => `${number?.toFixed(2)}%`
}

export const formatValue = (value: number, format: FormatOption): string => {
  return FORMATTERS[format](value)
}
